export default __webpack_public_path__ + "static/media/b45.1c3d5523.png";